<template>
  <div class="account-item">
    <div class="account-item__info">
      <AppleIcon />
      <span>
        {{ $t("message.apple.apple") }}
      </span>
    </div>
    <div class="account-item__user">
      {{ item.created_at }}
    </div>
    <div class="account-item__actions">
      <ui-button icon="icon-trash" iconColor="red" @click="toggleAlertDialog">
        {{ $t("message.common.removeAccount") }}
      </ui-button>
    </div>

    <AlertDialog
      v-if="showAlertDialog"
      :title="$t('message.facebook.accountRemoveAlert.title')"
      :description="$t('message.facebook.accountRemoveAlert.description')"
      @close="toggleAlertDialog"
      @confirm="deleteAccount"
    />
  </div>
</template>

<script>
import AppleIcon from "@/components/ui/Icons/AppleIcon.vue";
export default {
  name: "AccountItem",
  components: {
    AppleIcon,
    AlertDialog: () => import("@/components/FacebookAccounts/AlertDialog.vue")
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showAlertDialog: false
    };
  },
  methods: {
    toggleAlertDialog() {
      this.showAlertDialog = !this.showAlertDialog;
    },

    async deleteAccount() {
      this.$emit("delete-account");
      this.toggleAlertDialog();
    }
  }
};
</script>
<style scoped lang="scss">
.account-item {
  display: flex;
  align-items: center;
  padding: $spacing * 2 0;
  @include font-size(14px);

  & > * {
    padding: 0 $spacing;
  }

  &__info {
    display: flex;
    align-items: center;
    gap: $spacing;
    width: 160px;
  }

  &__user {
    display: flex;
    align-items: center;
    gap: $spacing;
    flex-grow: 1;
    flex-shrink: 0;
  }

  &__actions {
    width: 340px;
    flex-shrink: 0;
  }
}
</style>
